import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Componente que reinicia el scroll cuando cambia la ruta
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Reinicia el scroll al inicio de la página cuando cambia la ruta
    window.scrollTo(0, 0);
  }, [pathname]);

  return null; // Este componente no renderiza nada
}

export default ScrollToTop; 